// extracted by mini-css-extract-plugin
export var textInput = "_lk-0";